export default __webpack_public_path__ + "static/media/wedding7.188b45be.webp";